import * as types from '../mutations'

export default {
}
